import React from "react";
import { connect } from "react-redux";
import { FavouriteContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
import { Cards, Displays, Headers, Navigations } from "components";

class FavouriteContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { authenRedux } = this.props;
    let res = await userService.GET_QUESTION_LIST(
      `?is_active=true&pagination=false`,
    );
    if (res && res.status === 200) {
      this.setState({
        data: {
          ...res.data,
          docs: res.data.docs.filter(
            (e) =>
              !e.is_join ||
              (e.is_join && e.customer_joined_list.includes(authenRedux._id)),
          ),
        },
        isLoading: false,
      });
    }
  };

  handleClickItem = (e) => {
    this.props.router.navigate(
      `${ROUTE_PATH.SPECIAL_POINTS_FAV}/test/${e._id}`,
    );
  };

  render() {
    const { t } = this.props;
    const { isLoading, data } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Survey", { ns: "common" }),
        path: `${ROUTE_PATH.SPECIAL_POINTS}`,
      },
      {
        name: t("Favourite", { ns: "common" }),
        path: `${ROUTE_PATH.SPECIAL_POINTS_FAV}`,
      },
    ];
    return (
      <FavouriteContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="favourite_container">
          <div className="header_sec">
            <Headers.NewPageHeader title={"Survey"} sub_title={"แบบสอบถาม"} />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : !data || data.docs.length === 0 ? (
            <Displays.LabelEmpty label={t("No Data", { ns: "common" })} />
          ) : (
            <div className="fav_row">
              {data.docs.map((e, i) => (
                <div
                  key={i}
                  className="activities_item"
                  onClick={() => this.handleClickItem(e)}
                >
                  <Cards.Question
                    src={e.front_img}
                    title={e.title}
                    description={e.description}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </FavouriteContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common", "home"])(withRouter(FavouriteContainer)));
